import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserPuzzleSlider from 'src/games/PuzzleSlider/Main';

interface PuzzleSliderGameProps extends PageProps<{}> {
    onComplete?: () => void;
}

class PuzzleSliderGame extends React.Component<PuzzleSliderGameProps> {
    constructor(props: PuzzleSliderGameProps) {
        super(props);
        bindAllOfThis(this, PuzzleSliderGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserPuzzleSlider onComplete={this.completeGame} />
        </div>;
    }
}

export default PuzzleSliderGame;



// WEBPACK FOOTER //
// ./src/pages/game/PuzzleSliderGame.tsx